<template>

  <v-container v-if="image === undefined" fill-height fluid>
    <v-row align="center">
        <v-col align="center">
          <v-progress-circular
            indeterminate
            color="blue"
          ></v-progress-circular>
        </v-col>
    </v-row>
  </v-container>

  <v-container
    v-else
    style="padding: 0px;"
  >
    <v-app-bar light app color="white">
      <BackButton :backTarget="backTarget"/>
      <v-toolbar-title>Image information</v-toolbar-title>
    </v-app-bar>


    <v-row style="margin: 0px;">
      <ImagePreview :imageItem="image" :showFavIcon="userSignedIn"/>
    </v-row>

    <SignUpTeaser v-if="!userSignedIn"/>
    <v-container>
      <v-row justify="center">
        <v-col class="px-8">
          <v-btn
            color="primary"
            rounded
            block
            v-if="userSignedIn"
            v-clipboard="currentUrl"
            @click="snackbar = true"
          >Share</v-btn>
        </v-col>
      </v-row>

       <v-row
         align="center"
         justify="center">
           <v-col
           >
             <h3>Image source</h3>
             <a :href="image.url" target="_blank">
               {{image.url}}
             </a>
           </v-col>
       </v-row>
       <v-row
         align="center"
         justify="center">
           <v-col
           >
             <h3>From website</h3>
             <a :href="image.websiteUrl" target="_blank">
               {{image.websiteUrl}}
             </a>
           </v-col>
       </v-row>
     </v-container>

     <v-snackbar
       v-model="snackbar"
       centered
     >
       {{ snackbarText }}
       <template v-slot:action="{ attrs }">
         <v-btn
           color="blue"
           text
           v-bind="attrs"
           @click="snackbar = false"
         >
           OK
         </v-btn>
       </template>
     </v-snackbar>

  </v-container>
</template>

<script>
import SignUpTeaser from '../components/SignUpTeaser.vue'
import ImagePreview from '@/components/ImagePreview.vue'
// @ is an alias to /src
import BackButton from '@/components/BackButton.vue'

var unsubImage;

export default {
  name: 'PersonsWorkImage',
  components: {
    SignUpTeaser,
    ImagePreview,
    BackButton,
  },
  data() {
    return {
      currentUrl: window.location,
      snackbar: false,
      snackbarText: 'Copied link to clipboard!',
      image: undefined,
      imageQuery: this.$root.$data.db.collection('image').doc(this.$route.params.imageId),
      // personQuery: this.$root.$data.db.collection('person').doc(this.$route.params.personId),
      appState: this.$root.$data.appStore.state,
    }
  },
  computed: {
    userSignedIn: function () {
      return this.appState.user.uid !== undefined;
    },
    backTarget: function () {
      if(this.$route.params.personId) {
        return '/person/' + this.$route.params.personId;
      }
      return '/discover';
    }
  },
  methods: {
    async fetchImage() {
      try {
        let imageDoc = await this.imageQuery.get();
        this.image = {
          id: imageDoc.id,
          url: imageDoc.data().url,
          websiteUrl: imageDoc.data().websiteUrl,
          favouritedAt: imageDoc.data().favouritedAt,
        };
      } catch (error) {
        console.log(`Error fetching image data for id ${this.$route.params.imageId}: ${error}`)
        return;
      }

    },
  },
  mounted() {
    let fetchImageFunc = this.fetchImage;
    unsubImage = !unsubImage && this.imageQuery.onSnapshot(function() {
     fetchImageFunc();
    });
  },
  beforeDestroy: function () {
    if(unsubImage) {
      unsubImage();
      unsubImage = undefined;
    }
  },
}
</script>
